import { setNotification } from '../utils/notificationUtils';
import { ERROR } from '../layouts/notification/Notification';
import { storeType } from '../redux/store';

export const handle5xx = (store: storeType, err: any) => {
  if (err.response.data) {
    setNotification(err.response.data[0]?.message, [], ERROR, null);
  } else {
    setNotification('Unbekannter Server Fehler aufgetreten', [], ERROR, null);
  }
};
